import React from "react";
import { DSGVOCheckbox, Form, InputField, SubmitButton } from "../Form/Form";
import {__} from "@wordpress/i18n";
import {submitForm} from "../api/requests";

const hasMinLength = (value: string, minLength: number): boolean =>
    value.trim().length >= minLength;

const isPhoneNumber = (value: string): boolean =>
    /^[+()\d\s/-]{6,}$/.test(value.trim());

export function CallbackForm({text}: ({ text: string })): React.ReactElement {
    const onSubmit = async (event: SubmitEvent): Promise<void> => {
        event.preventDefault();

        const form = event.target as HTMLFormElement | null;

        if (!form) {
            return;
        }

        const formData = new FormData(form);

        await submitForm('callback-form', {
            company: (formData.get('company') ?? '').toString(),
            name: (formData.get('name') ?? '').toString(),
            phone: (formData.get('phone') ?? '').toString(),
            dsgvo: formData.has('dsgvo'),
        });
    };

    return (
        <div className="wvcb-card">
            <div className="wvcb-callback-form">
                <p>{text}</p>
                <Form onSubmit={onSubmit}>
                    <div className="container grid wrap">
                        <div className="column column--md-6">
                            <InputField
                                label={__('Unternehmen', 'wv-chat-bot')}
                                name="company"
                                required
                                validate={(value) => hasMinLength(value, 2)}
                                validationMessage={__('Bitte einen gueltigen Unternehmensnamen eingeben.', 'wv-chat-bot')}
                            />
                        </div>
                        <div className="column column--md-6">
                            <InputField
                                label={__('Vor- und Nachname', 'wv-chat-bot')}
                                name="name"
                                required
                                validate={(value) => value.trim().split(/\s+/).length >= 2}
                                validationMessage={__('Bitte Vor- und Nachname eingeben.', 'wv-chat-bot')}
                            />
                        </div>
                        <div className="column column--md-6">
                            <InputField
                                label={__('Telefonnummer', 'wv-chat-bot')}
                                name="phone"
                                type="tel"
                                required
                                validate={isPhoneNumber}
                                validationMessage={__('Bitte eine gueltige Telefonnummer eingeben.', 'wv-chat-bot')}
                            />
                        </div>
                        <div className="column column--md-6">
                            <InputField
                                label={__('Erreichbarkeit', 'wv-chat-bot')}
                                name="availability"
                                type="text"
                                required
                            />
                        </div>
                        <div className="column">
                            <DSGVOCheckbox/>
                        </div>
                        <div className="column">
                            <div className="buttons">
                                <SubmitButton label={__('Rückruf anfragen', 'wv-chat-bot')}/>
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    );
}
